const getBannersQuery = /* GraphQL */ `
  query GetBanners {
    banners: activeBanners {
      id
      title
      description
      mobileTitle
      promoCode
      promoCodeDescription
      startDate
      endDate
      url
      linkText
      bannerType {
        id
        name
      }
    }
  }
`

export default getBannersQuery
